<template>
  <div class="centerIt">
    <div class="d-flex flex-row">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
      <div class="ml-8 text-h5">{{ message }}</div>
    </div>
  </div>
</template>

<script>
// import Name from "../dir/file";

export default {
  name: "Loading",
  props: {
    message: {
      type: String,
      default: "Loading . . .",
    },
  },
  data: function () {
    return {};
  },
  methods: {},
  computed: {},
};
</script>

<style scoped>
.centerIt {
  width: 200px;
  margin: 100px auto;
}
</style>
